import { ApiItem } from '@ibe/api';
import AnalyticsBase from './AnalyticsBase';

class ItemDetailListEvent extends AnalyticsBase {
  items: Array<ApiItem>;
}

export default ItemDetailListEvent;
